import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/common/constants/routes';
import { Button, Flex, Heading, Text } from '@coverflex-tech/hypernova';
import { useRouter } from 'expo-router';

type TIntroProps = {
  onNext: () => void;
};

export const Intro = ({ onNext }: TIntroProps) => {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <Flex flexDirection="column" gap="lg">
      <Flex flexDirection="column" gap="sm">
        <Heading level={3}>{t('activate_card.intro.title')}</Heading>
        <Text>{t('activate_card.intro.description')}</Text>
      </Flex>
      <Flex gap="lg" flexWrap="wrap">
        <Button
          variant="secondary"
          onClick={() => {
            router.dismissTo(ROUTES.CARD);
          }}
        >
          {t('general.navigation.cancel')}
        </Button>
        <Button onClick={onNext}>{t('activate_card.intro.action')}</Button>
      </Flex>
    </Flex>
  );
};
